import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function combinedStringsLengthValidator(str1: string, str2: string, targetLength = 1): ValidatorFn {
	return (group: UntypedFormGroup) => {
		const controls = group.controls;
		const string1 = controls[str1]?.value;
		const string2 = controls[str2]?.value;
		if (!string1 && !string2) {
			return null;
		} else {
			if ((string1 || '').length + (string2 || '').length < targetLength) {
				return {
					combinedStringsInvalid: true,
				};
			} else return null;
		}
	};
}
